module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/nba/survive-56f4f68b4524764b8b7b82c3fb3eeeb4.svg";